import React from 'react';

import { ArrowUp } from 'lucide-react';

export const Coverage = () => {
    const scorePct = 75;
    const deltaPct = 2;
    const avgSesions = 2.7;
    const avgSessionLength = '12.5m';

    return (
        <div className='card card--md card--radius-sm dashboard__stats_card__mbts__coverage'>
            <p className='text-medium'>Coverage</p>
            <div className="dashboard__stats_card__mbts__coverage__content">
                <div className="dashboard__stats_card__mbts__coverage__content__left">
                    <div
                        className="dashboard__stats_card__mbts__coverage__donut"
                        style={{ ['--progress' as unknown as string]: scorePct } as React.CSSProperties}
                        role="img"
                        aria-label={`Coverage score ${scorePct}%`}
                    >
                        <p className="text-2xl text-semibold text-center">
                            {scorePct}%
                        </p>
                    </div>

                    <div className="d-flex align-items-center gap-sm">
                        <div className="d-flex align-items-center gap-xs">
                            <ArrowUp size={20} className='color--success-strong' />
                            <p className="text-sm text-medium color--success-strong">{deltaPct}%</p>
                        </div>
                        <p className="text-sm text-medium color--txt-muted">vs last month</p>
                    </div>
                </div>
                <div className="dashboard__stats_card__mbts__coverage__content__right">
                    <div className='d-flex flex-column justify-content-between align-items-end gap-xl'>
                        <div>
                            <p className='text-4xl text-semibold text-right mb-md'>{avgSesions}</p>
                            <p className='text-sm text-medium color--txt-muted text-right'>Avg Sessions / User</p>
                        </div>
                        <div>
                            <p className='text-4xl text-semibold text-right mb-md'>{avgSessionLength}</p>
                            <p className='text-sm text-medium color--txt-muted text-right'>Avg Session Length</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};